import graphql from "babel-plugin-relay/macro";

import { Route, RouterToFactory } from "../../../types";

export const route: Route = {
  getComponent: (_, cb) => {
    import("./Group").then(module => cb(null, module.default));
  },
  path: "groups/:groupUuid",
  title: "Group",
  query: graphql`
    query route_Group_Query($uuid: ID!) {
      ...Group_query
    }
  `,
  prepareVariables: props => ({
    uuid: props.params.groupUuid
  }),

  getIndexRoute: (_, cb) => {
    import("../SubGroups/route").then(module => cb(null, module.route));
  },
  getChildRoutes: (_, cb) => {
    Promise.all([
      // import("../Members/route").then(module => module.route),
      import("../GroupSettings/route").then(module => module.route)
    ]).then(routes => cb(null, routes));
  }
};

export const groupLocation: RouterToFactory = uuid => ({
  pathname: `groups/${uuid}`
});
